import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: null, status: 'idle', error: null };

const userCartoonsSlice = createSlice({
  name: 'userCartoons',
  initialState,
  reducers: {
    userCartoonsRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    userCartoonsSuccess(state, action) {
      state.status = 'succeeded';
      state.data = action.payload;
    },
    userCartoonsFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    userCartoonsReset(state) {
      state.status = 'idle';
      state.error = null;
      state.data = null;
    },
  },
});

export const userCartoonsAction = userCartoonsSlice.actions;
export default userCartoonsSlice;